import ArrowDownLeftIcon from "../../../../../icons/ArrowDownLeft";
import ArrowUpRightIcon from "../../../../../icons/ArrowUpRight";
import { CommunicationDirection } from "../../../types/clients.types";

interface CommunicationDirectionIconProps {
    direction?: string | null;
}

export default function CommunicationDirectionIcon({
    direction,
}: CommunicationDirectionIconProps) {
    const isInbound =
        direction?.toLowerCase() ===
        CommunicationDirection.INBOUND.toLowerCase();
    const isOutbound =
        direction?.toLowerCase() ===
        CommunicationDirection.OUTBOUND.toLowerCase();

    if (!isInbound && !isOutbound) return null;

    const label = isInbound ? "Incoming" : "Outgoing";

    return (
        <span
            role="img"
            aria-label={label}
            title={label}
            className={
                isInbound
                    ? "text-[--color-info-text]"
                    : "text-[--color-neutral-text]"
            }
        >
            {isInbound ? <ArrowDownLeftIcon /> : <ArrowUpRightIcon />}
        </span>
    );
}
